export const isValidURL = (url?: string) => {
    const URL_REGEX =
        /^(https?:\/\/)?(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?$/;
    return url && URL_REGEX.test(url);
};

export const cleanEmail = (email?: string | null): string =>
    email?.toLowerCase().replace(/\s/g, "") ?? "";
